import React from 'react';

interface FileSearchBarProps {
    onSearch?: (searchTerm: string) => void;
    searchValue?: string;
    useFormSubmit?: boolean;
}

const FileSearchBar: React.FC<FileSearchBarProps> = ({ 
    onSearch, 
    searchValue = '', 
    useFormSubmit = false 
}) => {
    const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (onSearch) {
            onSearch(e.target.value);
        }
    };

    // If no onSearch callback provided, use the old form submission method
    if (useFormSubmit || !onSearch) {
        return (
            <form className='searchhome' method="GET" action="/search">
                <i className="fa fa-search d-inline-block" />
                <input 
                    type="text" 
                    name="k" 
                    className="form-control search-bar d-inline-block" 
                    placeholder="Search by File number, Subject, and Comp. No." 
                />
            </form>
        );
    }

    // New controlled input for real-time search
    return (
        <div className='searchhome'>
            <i className="fa fa-search d-inline-block" />
            <input 
                type="text" 
                value={searchValue}
                onChange={handleSearchChange}
                className="form-control search-bar d-inline-block" 
                placeholder="Search by File number, Subject, and Comp. No." 
            />
        </div>
    );
};

export default FileSearchBar;